import { useEffect } from 'react'

export default function useUpdatePaymentRequest({ paymentItem, paymentRequest }) {
  useEffect(() => {
    if(paymentRequest) paymentRequest.update({ total: {...paymentItem} })
  }, [paymentItem.amount]);
}